import objectFitImages from 'object-fit-images';
import 'intersection-observer'

objectFitImages();
IntersectionObserver.prototype.POLL_INTERVAL = 100;